import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import QuizContainer from "../../components/Quiz/QuizContainer";
import { QuizHeader } from "../../components/Quiz/QuizHeader";
import api from "../../utils/api";
import styled from "@emotion/styled";
import { Table } from "antd";
import { fontFamiliy } from "../../components/ReportMonk/constant";
import { Spin } from "antd";

export const RightAnswer = () => {
  const [quizList, setQuizList] = useState([]);
  const [imageList, setImageList] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const getTableColumns = () => {
    if (quizList.length <= 0) return [];

    let maxSequece = -1;
    for (let i = 0; i < quizList.length; ++i) {
      if (quizList[i].rightAnswers.length > maxSequece)
        maxSequece = quizList[i].rightAnswers.length;
    }

    let columns = [
      {
        title: "เล่ม",
        dataIndex: "group",
        key: "group",
        render: (g) => (
          <>
            <TitleImage>เล่มที่ {g}</TitleImage>
            <img
              src={imageList[parseInt(g) - 1]}
              style={{
                maxHeight: "77px",
                maxWidth: "54px",
                marginBottom: "10px",
              }}
            />
          </>
        ),
      },
    ];
    for (let i = 0; i < maxSequece; ++i)
      columns.push({
        title: `ข้อที่ ${i + 1}`,
        dataIndex: `sequence${i + 1}`,
        key: `rightAnswers-${i + 1}`,
        render: (r) => (
          <>
            <TitleImage fontWeight={400}>{`${r})`}</TitleImage>
          </>
        ),
      });

    return columns;
  };

  const convertArrayRightAnswersToObject = (rightAnswers) => {
    const result = {};

    for (let i = 0; i < rightAnswers.length; ++i)
      result[`sequence${rightAnswers[i].sequence}`] =
        rightAnswers[i].rightAnswer;

    return result;
  };

  useEffect(() => {
    api
      .get("/quiz/getQuizRightAnswers")
      .then((res) => {
        if (res.status === 200) setQuizList(res.data?.quizMasterList);
      })
      .catch((err) => {
        setIsLoading(false);
        alert(err?.response?.data);
      });
  }, []);

  useEffect(() => {
    if (quizList.length > 0)
      Promise.all(
        quizList.map((q) =>
          import(`../../assets/images/quiz/books/${q.group}.svg`)
        )
      ).then((r) => {
        setImageList(r.map((r) => r.default));
        setTimeout(() => {
          setIsLoading(false);
        }, 200);
      });
  }, [quizList]);

  return (
    <QuizContainer>
      <Spin size="large" tip="กำลังโหลดข้อมูล" spinning={isLoading}>
        <center>
          <QuizHeader>เฉลยแบบทดสอบออนไลน์รวม 10 เล่ม</QuizHeader>
          <SubHeader>ชุดความรู้เณรกล้าโภชนาดี</SubHeader>
        </center>
        {quizList.length > 0 && imageList.length > 0 && (
          <>
            <CustomTable
              dataSource={quizList.map((q) => ({
                group: q.group,
                ...convertArrayRightAnswersToObject(q.rightAnswers),
              }))}
              columns={getTableColumns()}
              bordered
              pagination={false}
              scroll={{ x: 840, y: 500 }}
            />
          </>
        )}
      </Spin>
    </QuizContainer>
  );
};

export default RightAnswer;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30%;
`;

const SubHeader = styled.p`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #4b5768;
`;

const TitleImage = styled.p`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 600)};
  font-size: 12px;
  margin-top: 10px;
  margin-bottom: 0px;
  color: #4b5768;
`;

const CustomTable = styled(Table)`
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td,
  .ant-table tfoot > tr > th,
  .ant-table tfoot > tr > td {
    position: relative;
    padding: 0;
    height: 36px;
    overflow-wrap: break-word;
    white-space: pre-line;

    font-family: ${fontFamiliy}
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 14px;

    text-align: center;

    color: #4b5768;
  }

  .ant-table-header {
    border-left: 1px solid #4b5768;
    border-top: 1px solid #4b5768;
    border-right: 1px solid #4b5768;
    border-radius: 8px 8px 0px 0px;
  }

  .ant-table-body {
    border-left: 1px solid #4b5768;
    border-bottom: 1px solid #4b5768;
    border-right: 1px solid #4b5768;
    border-radius: 0px 0px 8px 8px;
  }

  *::-webkit-scrollbar {
    height: 15px !important;
  }
`;
